/**
 * useAdminTicketEvents
 * 
 * Fetches events with ticket types for ticket operators.
 * Different from raffle events - includes ticket usage stats.
 */

import { useQuery } from "urql";

// =============================================================================
// TYPES
// =============================================================================

export interface TicketEventSummary {
  id: string;
  title: string;
  coverImage: string | null;
  startDate: string | null;
  endDate: string | null;
  ticketTypesCount: number;
  ticketsCount: number;
  usedTicketsCount: number;
}

// =============================================================================
// QUERY DOCUMENT
// =============================================================================

const AdminTicketEventsDocument = `
  query AdminTicketEvents {
    adminTicketEvents {
      id
      title
      coverImage
      startDate
      endDate
      ticketTypesCount
      ticketsCount
      usedTicketsCount
    }
  }
`;

// =============================================================================
// HOOK
// =============================================================================

export function useAdminTicketEvents() {
  const [result] = useQuery<{ adminTicketEvents: TicketEventSummary[] }>({
    query: AdminTicketEventsDocument,
  });

  return {
    events: result.data?.adminTicketEvents ?? [],
    isLoading: result.fetching,
    error: result.error,
  };
}
